import { useState, useEffect } from 'react';
import {
    collection,
    query,
    onSnapshot,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    serverTimestamp,
    orderBy,
    setDoc
} from 'firebase/firestore';
import { db } from '../firebase';

export const usePrintSets = (playbookId) => {
    const [printSets, setPrintSets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!playbookId || playbookId === 'local') {
            setPrintSets([]);
            setLoading(false);
            return;
        }

        const q = query(
            collection(db, 'playbooks', playbookId, 'printSets'),
            orderBy('timestamp', 'desc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const setsList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                timestamp: doc.data().timestamp?.toDate ? doc.data().timestamp.toDate().getTime() : doc.data().timestamp
            }));
            setPrintSets(setsList);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching print sets:", error);
            setLoading(false);
        });

        return unsubscribe;
    }, [playbookId]);

    const savePrintSet = async (setId, setData, userInfo = {}) => {
        if (!playbookId || playbookId === 'local') return;

        const { uid, email, displayName } = userInfo || {};

        const setPayload = {
            ...setData,
            updatedAt: serverTimestamp(),
            updatedBy: uid || null,
            updatedByName: displayName || email || 'Unknown',
            timestamp: serverTimestamp() // Main timestamp for ordering
        };

        if (setId && setId.toString().length > 13) { // Firestore IDs are usually long strings, Date.now() is 13 digits
            const setRef = doc(db, 'playbooks', playbookId, 'printSets', setId);
            return await updateDoc(setRef, setPayload);
        } else {
            const setRef = doc(collection(db, 'playbooks', playbookId, 'printSets'));
            return await setDoc(setRef, {
                ...setPayload,
                id: setRef.id,
                playbookId,
                createdAt: serverTimestamp()
            });
        }
    };

    const deletePrintSet = async (setId) => {
        if (!playbookId || playbookId === 'local') return;
        return await deleteDoc(doc(db, 'playbooks', playbookId, 'printSets', setId));
    };

    return { printSets, loading, savePrintSet, deletePrintSet };
};
